// removed by extract-text-webpack-plugin
module.exports = {"form":"login__form__3Zwuh","title":"login__title__1s4_r","h1":"login__h1__3gbiF login__title__1s4_r","input":"login__input__2B3L7","button":"login__button__1IYK- login__title__1s4_r","error":"login__error__16e9_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/login/login.scss
// module id = 87
// module chunks = 0